import { cmsAxiosInstance } from '../configuration/axiosConfig';
import { ClientResponse } from '../model/ClientResponse';
import Predpis from '../model/Predpis';
import PredpisCudziJazyk from '../model/PredpisCudziJazyk';

const getValue = (resp: object[], name: string): string => {
  const field = resp.find(item => item['@name'] === name);
  const value = field && field['0'] && field['0'].text;
  return value || '';
};

const getJazykyList = (resp: object[], name: string): {
  id: string, name: string, iconPath: string,
  jazyk: string
}[] => {
  const jazykyList: { id: string, name: string, iconPath: string, jazyk: string }[] = [];
  if (name === 'jazyky') {
    const jazyky = resp.find((item) => item['@name'] === 'jazyky');
    if (jazyky) {
      Object.keys(jazyky)
        .forEach((key) => {
          const field = jazyky[key];
          if (field.jazyk) {
            jazykyList.push({
              id: field['@id'],
              name: field['@name'],
              iconPath: `${process.env.REACT_APP_MAGNOLIA_API_BASE_PATH + field.ikona}`,
              jazyk: field.jazyk,
            });
          }
        });
    }
  }
  return jazykyList;
};

const mapResponse = (data: object[]): Predpis => ({
  nadpis: getValue(data, 'nadpis'),
  popis: getValue(data, 'popis'),
  upozornenie: getValue(data, 'upozornenie'),
  jazyky: getJazykyList(data, 'jazyky'),
});

export const getPredpisyPage = async ():
  Promise<ClientResponse<Predpis>> => {
  const {
    data,
    status,
  } = await cmsAxiosInstance.get(
    '/predpisy/@nodes',
  );

  return {
    data: mapResponse(data),
    responseCode: status,
  };
};

export const getPredpisyCudziJazykPage = async (id: string | undefined):
  Promise<ClientResponse<PredpisCudziJazyk>> => {
  const {
    data,
    status,
  } = await cmsAxiosInstance.get(
    `/jazyky/${id}`,
  );

  if ((!data.popis || !data.upozornenie || !data.nadpis) && status <= 399) {
    const response = await cmsAxiosInstance.get(
      '/predpisy/@nodes',
    );
    return {
      data:
        {
          ...data,
          ...{
            popisSk: getValue(response.data, 'popis'),
            upozornenieSk: getValue(response.data, 'upozornenie'),
          },
        },
      responseCode: response.status,
    };
  }

  return {
    data,
    responseCode: status,
  };
};

export const getPredpisyCudziJazykPredpisy = async (id: string | undefined, limit, page):
  Promise<ClientResponse<PredpisCudziJazyk>> => {
  const offset = (page - 1) * limit;
  const response = await cmsAxiosInstance.get(
    // eslint-disable-next-line max-len
    `/jazyky?orderBy=predpisSk asc&@ancestor=/predpisy/jazyky/${id}/predpisy&limit=${limit}&offset=${offset}`,
  );

  return {
    data: response.data,
    responseCode: response.status,
  };
};
